import { render } from "./BannerShow.vue?vue&type=template&id=46f67cba&scoped=true"
import script from "./BannerShow.vue?vue&type=script&lang=js"
export * from "./BannerShow.vue?vue&type=script&lang=js"

import "./BannerShow.vue?vue&type=style&index=0&id=46f67cba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f67cba"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/BannerShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46f67cba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46f67cba', __exports__)) {
    api.reload('46f67cba', __exports__)
  }
  
  module.hot.accept("./BannerShow.vue?vue&type=template&id=46f67cba&scoped=true", () => {
    api.rerender('46f67cba', render)
  })

}


export default __exports__